import { render, staticRenderFns } from "./page-tracker.vue?vue&type=template&id=c56bef14&"
import script from "./page-tracker.vue?vue&type=script&lang=js&"
export * from "./page-tracker.vue?vue&type=script&lang=js&"
import style0 from "./page-tracker.vue?vue&type=style&index=0&id=c56bef14&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports